// 获取根域名的函数
export function getRootDomain() {
    let hostname = window.location.hostname;
    let parts = hostname.split('.');
    if (parts.length > 2) {
        parts = parts.slice(parts.length - 2);
    }
    return parts.join('.');
}


export function getAppid() {
    let domain_map = {
        'mangabuz.com': 1,
        'mayonn.click': 2,
        'neopad.click': 3,
        'glodream.click': 4,
        'pixcho.click': 4,
        'mospix.click': 5,
        'creovio.click': 6,
        'artavo.click': 7,
        'graphilo.click': 8,
        'epicraft.click': 9,
        'inkzo.click': 10,
        'comiczoom.click': 11,
        'serixapp.click': 12,
        'comicbuz.com': 99,
    };
    let rootDomain = getRootDomain();
    if (domain_map[rootDomain]) {
        return domain_map[rootDomain];
    }

    let host_map = {
        'pco.mellowgra.com': 4,
        'wp.mellowgra.com': 5,
        'cov.mellowgra.com': 6,
        'art.mellowgra.com': 7,
        'gap.mellowgra.com': 8,
        'epi.mellowgra.com': 9,
        'ink.mellowgra.com': 10,
        'czi.mellowgra.com': 11,
        'ser.mellowgra.com': 12,
    }
    let hostname = window.location.hostname;
    if (host_map[hostname]) {
        return host_map[hostname];
    }

    return domain_map['comiczoom.click'];
}

import {showToast} from "vant";
export function getEnKey(){
    let EnKeyMap = {
        1: 'MBn5YziBAEJAHw7hzAHzJ0',
        2: 'MG6ycGKfWP50Y4wc4j7j5G',
        3: 'MG6ycGKfWP50Y4wc4j7j5G',
        4: 'GLn5YziBaEJAHd7hzAHzJp',
        5: 'MM6ycGafAP59Y4wc4jbj5G',
        6: 'MG6ycGKfWP50Y4wc4j7j5G',
        7: 'GLn5YziBaEJAHd7hzAHzJp',
        8: 'MM6ycGafAP59Y4wc4jbj5G',
        9: 'GLn5YziBaEJAHd7hzAHzJp',
        10: 'GLn5YziBaEJAHd7hzAHzJp',
        11: 'GLn5YziBaEJAHd7hzAHzJp',
        12: 'MM6ycGafAP59Y4wc4jbj5G',
    }

    // 获取当前主机名的根域名
    let appid = getAppid();
    if (EnKeyMap[appid]) {
        return EnKeyMap[appid];
    }else{
        showToast('Failed to obtain data, please contact customer service')
        return EnKeyMap[9];
    }
}

export function parseUserAgent(userAgent) {
    const result = {
        platform: 0,   // 'ios':2 或 'android':1, 未知0
        version: '',    // 应用版本号
    };

    if (!userAgent || typeof userAgent !== 'string') {
        return result;
    }

    if (userAgent.includes('android_version')) {
        result.platform = 1;
        // 提取 Android 版本号
        const match = userAgent.match(/android_version=([\d.]+)/);
        result.version = match ? match[1] : '';
    }else if(userAgent.includes('ios_version')) {
        result.platform = 2;
        // 提取 iOS 版本号
        const match = userAgent.match(/ios_version=([\d.]+)/);
        result.version = match ? match[1] : '';
    }

    return result;
}

import CryptoJS from 'crypto-js';
export function decryptAndDecompress(data) {
    if(!data.timestamp) return data

    const base64EncodedData = data.data
    const timestamp = data.timestamp;

    const en_key = getEnKey();
    const iv = CryptoJS.MD5(en_key + timestamp).toString().substring(6, 22);
    const key = (en_key + timestamp).padEnd(32, '0').slice(0, 32);

    const encryptedData = CryptoJS.enc.Base64.parse(base64EncodedData);

    try {
        const decrypted = CryptoJS.AES.decrypt({
            ciphertext: encryptedData
        }, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const decryptedText = CryptoJS.enc.Utf8.stringify(decrypted);

        return JSON.parse(decryptedText);
    } catch (error) {
        console.error('error:', error.message);
        showToast('Failed to obtain data, please contact customer service')
        return false;
    }
}

